// skipcq: JS-W1028
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
//
import { UserContext } from '../context/UserContext';
import PageLoadingIndicator from '../components/widgets/PageLoadingIndicator';

const GlobalAdminRoute = ({ children }) => {
  const user = useContext(UserContext);

  // Show loading while authentication state is being determined
  if (user.isLoading) {
    return <PageLoadingIndicator title="Loading..." />;
  }

  if (!user.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (user.emailVerified === false) {
    return <Navigate to="/verify-email" replace />;
  }

  if (!user.isGlobalAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default GlobalAdminRoute;
